export default __webpack_public_path__ + "static/media/edit-icon.86379290.png";